<template>
  <div class="col-lg">
    <div class="preview-div">
      <div class="preview-wrapper" v-if="showOld">
        <div class="sr-only">
          <pre>{{ numbers }}</pre>
          <pre>recipients: {{ recipients }}</pre>
          <pre>{{ template }}</pre>
        </div>
        <div class="qt-loader" v-if="uploading || sending"></div>

        <template>
          <div class="card card-preview relative" v-if="template">
            <div class="card-body">
              <template v-if="headerType">
                <!-- <div class="relative">
                </div> -->
                <p class="card-text card-header" v-if="headerType === 'TEXT'">
                  {{ headerPreview }}
                </p>
                <div v-else-if="headerType === 'IMAGE'" class="img-wrapper">
                  <img :src="headerImage" v-if="headerImage" alt="" />
                  <div v-else class="image-container">
                    <svg width="221" height="94" viewBox="0 0 221 94" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.6875 8.76977C0.6875 4.35149 4.26922 0.769775 8.6875 0.769775H212.558C216.976 0.769775 220.558 4.3515 220.558 8.76978V85.1427C220.558 89.561 216.976 93.1427 212.558 93.1427H8.6875C4.26922 93.1427 0.6875 89.561 0.6875 85.1427V8.76977Z"
                        fill="url(#pattern0)"
                      />
                      <defs>
                        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_3256_45342" transform="scale(0.00078125 0.00184502)" />
                        </pattern>
                        <image
                          id="image0_3256_45342"
                          width="1280"
                          height="542"
                          xlink:href="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                  </div>
                </div>
                <header v-else-if="headerType === 'VIDEO'">
                  <div class="media d-flex justify-content-center midia-container-template">
                    <video :src="headerVideo" v-if="headerVideo" controls></video>
                    <div class="image-container" v-else>
                      <img src="/assets/img/video_preview.png" />
                    </div>
                  </div>
                </header>
                <header v-else-if="headerType === 'DOCUMENT'">
                  <div class="media document">
                    <!-- <object
                      type="application/pdf"
                      :data="headerCurrentDocument"
                      v-if="headerCurrentDocument"></object> -->
                    <div class="image-container">
                      <img src="/assets/img/document_preview.png" />
                    </div>
                  </div>
                </header>
              </template>
              <p class="card-text">
                {{ bodyPreview }}
              </p>
              <p class="card-text footer-item">
                {{ footerBody }}
              </p>
              <div class="preview-message-btns" v-if="template.buttons">
                <template v-if="template.buttons.type === 'QUICK_REPLY' && template.buttons.quick_replies">
                  <div class="btn-link-preview">
                    <template v-for="(reply, i) in template.buttons.quick_replies.filter((a) => !!a)">
                      <button type="button" class="btn" :key="i" :class="{ max: i === 2 }">{{ reply }}</button>
                    </template>
                  </div>
                </template>
                <template v-if="template.buttons.type === 'CALL_TO_ACTION'">
                  <div class="btn-link-preview" v-if="Object.keys(template.buttons.call_to_action_dial_phone).length">
                    <div class="btn max">
                      <i class="fas fa-phone"></i>
                      {{ template.buttons.call_to_action_dial_phone.text }}
                    </div>
                  </div>
                  <div class="btn-link-preview" v-if="Object.keys(template.buttons.call_to_action_website).length">
                    <a class="btn max" :href="template.buttons.call_to_action_website.url" target="_blank">
                      <i class="fas fa-link"></i>
                      {{ template.buttons.call_to_action_website.text }}
                    </a>
                    <!-- <div
                      class="btn last">
                    </div> -->
                  </div>
                </template>
              </div>
            </div>
          </div>
          <img class="phone-img" src="@/assets/phone.svg" alt="Phone Background" />
          <div class="card card-options hide">
            <div class="card-header">
              {{ $t('options-div.title') }}
              <b-button v-b-toggle.collapse-1 variant="transparent p-0 stretched-link" v-model="visible" @click="visible = !visible">
                <span class="material-icons-outlined chevron" :class="visible === false ? '' : 'open'">expand_more</span></b-button
              >
            </div>
            <b-collapse id="collapse-1">
              <div class="card-body">
                <template v-if="extras">
                  <div class="control-group opt-2 mb-3">
                    <label class="control control-checkbox d-flex" for="scheduleWA"
                      ><input id="scheduleWA" v-model="scheduled" type="checkbox" name="schedule" @change="() => {}" />
                      <div class="control_indicator mr-2"></div>
                      <span class="text-white">{{ $t('options-div.lbl-schedule') }}</span>
                    </label>
                  </div>
                  <div class="mb-3">
                    <date-picker v-if="scheduled" v-model="scheduledFor" :config="options" class="form-control input-date" :placeholder="$t('generic-str.date-hour')" />
                  </div>
                </template>
                <div class="mb-3">
                  <select
                    :disabled="!numbers || numbers.length < 2"
                    class="form-control"
                    aria-label="Default select example"
                    v-model="currentNumberIndex"
                    @change="fetchTemplates()"
                  >
                    <template v-for="(item, i) of numbers">
                      <option :key="i" :value="i">{{ item.phone_number }} ({{ item.name }})</option>
                    </template>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="text-white" for="template">Template</label>
                  <select id="template" class="form-control" aria-label="Default select example" v-model="currentTemplateIndex" @change="changeTemplate">
                    <option value="">Selecione o template...</option>
                    <template v-for="(item, i) of templates">
                      <option :key="i" :value="i">{{ item.name }} ({{ item.language }})</option>
                    </template>
                  </select>
                </div>
                <div class="my-3" v-if="headerType">
                  <div v-if="headerType === 'TEXT' && headerBody.indexOf('{{1}}') !== -1">
                    <label for="headerParam">Paremetro do header</label>
                    <input id="headerParam" class="form-control" type="text" v-model="headerParam" />
                  </div>
                  <input type="file" accept="video/*" class="form-control" :class="{ 'd-none': headerType !== 'VIDEO' }" @change="selectFile" />
                  <input type="file" accept="application/pdf" class="form-control" :class="{ 'd-none': headerType !== 'DOCUMENT' }" @change="selectFile" />
                  <!-- <input
                        type="file"
                        accept="image/jpeg,image/png"
                        class="form-control"
                        :class="{ 'd-none': headerType !== 'IMAGE' }"
                        @change="selectFile"> -->
                  <div v-if="headerType === 'IMAGE'">
                    <button class="btn btn-primary" @click="chooseImage(500, 280)">Escolher JPG ou PNG</button>
                  </div>
                </div>
                <div class="my-3" v-if="templateBodyParams && templateBodyParams.length">
                  <h3 class="text-white">Corpo</h3>
                  <template v-for="(example, i) in templateBodyParams">
                    <div class="my-2" :key="`body_example_${i}`">
                      <label class="text-white" :for="`body_example_${i}`">Parametro {{ i + 1 }}</label>
                      <input :id="`body_example_${i}`" class="form-control" type="text" :placeholder="example" v-model="bodyParams[i]" />
                    </div>
                  </template>
                </div>
              </div>
            </b-collapse>
          </div>
          <!-- <div class="row mt-3"> -->
          <!-- Old code here -->
          <!-- <div class="col-12 col-lg-4">
            </div>
          </div> -->
          <!-- <hr class="my-4"> -->
        </template>
        <div class="alert alert-danger" role="alert" v-if="error">
          <div class="d-flex">
            <div class="p-2">Templates não foram carregados</div>
            <div class="ml-auto p-2">
              <button class="btn btn-primary" @click="fetchNumbers()">Atualizar</button>
            </div>
          </div>
        </div>
      </div>
      <div class="preview-wrapper" v-else-if="template.type">
        <div class="card-preview" v-if="template.type == 'DEFAULT'">
          <WhatsappBubble :header="template.header">{{ template.body.text }}</WhatsappBubble>
          <div v-if="template.buttons.type === 'QUICK_REPLY'">
            <WhatsappButton v-for="(reply, i) in template.buttons.quick_replies" :key="i">
              {{ reply }}
            </WhatsappButton>
          </div>
          <div v-if="template.buttons.type === 'CALL_TO_ACTION'">
            <WhatsappButton>
              {{ template.buttons.call_to_action_website ? template.buttons.call_to_action_website.text : template.buttons.call_to_action_dial_phone.text }}
            </WhatsappButton>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'AUTH' || template.buttons.type === 'OTP'">
          <div class="card" style="width: 300px">
            <div class="card-body">
              <p class="m-b-0">
                Seu código de verificação é <strong>{{ template.button_parameter }}</strong>
              </p>
              <p v-if="template.footer.code_expiration_minutes" class="minutes-info">Esse código expira em {{ template.footer.code_expiration_minutes }} minutos</p>
              <div class="card-text"><span class="time-span">10:20</span></div>
              <div class="btn-whats-message">
                <a><span class="material-symbols-outlined to-left">content_copy</span> Copiar código</a>
              </div>
            </div>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'CAROUSEL'">
          <div class="card" style="margin-bottom: 10px">
            <div class="card-body">
              <div class="card-text">{{ template.body.text }} <span class="time-span">10:20</span></div>
              <footer class="card-text footer-item" v-if="template.footer">{{ template.footer.body }}</footer>
            </div>
          </div>
          <div style="overflow-x: auto" class="d-flex">
            <div v-for="(card, n) in template.carousel.content.cards" :key="n" class="col-8" style="padding: 0px; padding-right: 10px">
              <div class="card card-whats-message">
                <div class="card-content">
                  <div class="card-img d-flex">
                    <img class="card-img-top img-fluid" style="height: 160px" :src="card.components[0].example.header_handle[0]" alt="Card image cap" />
                    <div class="img-upload-icon">
                      <ImageUploader
                        @upload="
                          (file) => {
                            callUpload(file, card);
                          }
                        "
                      >
                        <span class="material-icons card-upload-btn absolute" v-tooltip.top="'Atualizar foto'"> upload </span>
                      </ImageUploader>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="card-text">{{ card.components[1].text }}</div>
                    <div v-if="card.components[1].example">
                      <div class="form-group row" v-for="(example, i) in card.components[1].example.body_text[0]" :key="i">
                        <div class="col-1">
                          <span class="material-symbols-outlined info-icons info-var color-bcbcbc">data_object</span>
                        </div>
                        <div class="col-10">
                          <input
                            type="text"
                            v-model="card.components[1].example.body_text[0][i]"
                            class="input-example-card form-control form-control-send"
                            :placeholder="'Variável para {{' + (i + 1) + '}}'"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="btn-whats-message">
                      <a><span class="material-symbols-outlined to-left">open_in_new</span> Web site</a>
                    </div>
                    <div class="btn-whats-message">
                      <a><span class="material-symbols-outlined to-left">reply</span> Quick Replay</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'CATALOG'">
          <div style="overflow-x: auto" class="d-flex">
            <div class="col-9" style="padding: 0px; padding-right: 10px">
              <div class="card card-whats-message">
                <div class="card-content card-catalog">
                  <div class="card-img d-flex">
                    <div class="prod-preview">
                      <img class="card-img-top img-fluid" :src="'https://framerusercontent.com/images/45uA4nlH9K2klcAVTjkwsps0A0I.png'" alt="Card image cap" />
                      <div>
                        <h3>Catálogo de exemplo</h3>
                        <p>Lorem Ipsum is simply dummy</p>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <p class="card-text">{{ template.body.text }} <span class="time-span">10:20</span></p>
                    <footer class="card-text footer-item" v-if="template.footer">{{ template.footer.body }}</footer>
                    <div class="btn-whats-message">
                      <a>Ver catálogo</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'MPM'">
          <div style="overflow-x: auto" class="d-flex">
            <div class="col-9" style="padding: 0px; padding-right: 10px">
              <div class="card card-whats-message">
                <div class="card-content card-catalog">
                  <div class="card-img d-flex">
                    <div class="prod-preview">
                      <img
                        class="card-img-top img-fluid"
                        src="https://framerusercontent.com/images/45uA4nlH9K2klcAVTjkwsps0A0I.png"
                        alt="Card image cap"
                        style="width: 70px; height: 50px; padding: 0px !important"
                      />
                      <div>
                        <h3>{{ template.header.body }}</h3>
                        <p>10 itens</p>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <p class="card-text">{{ template.body.text }} <span class="time-span">10:20</span></p>
                    <footer class="card-text footer-item" v-if="template.footer">{{ template.footer.body }}</footer>
                    <div class="btn-whats-message">
                      <a>Ver produtos</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'OFFER'">
          <div style="overflow-x: auto" class="d-flex">
            <div class="col-9" style="padding: 0px; padding-right: 10px">
              <div class="card card-whats-message">
                <div class="card-content card-catalog">
                  <div class="card-img d-flex">
                    <img v-if="headerType === 'IMAGE'" class="card-img-top img-fluid h-160" :src="headerImage" alt="Card image cap" />
                    <header v-else>
                      <div class="media">
                        <video class="video-header" :src="headerVideo" v-if="headerVideo" controls></video>
                      </div>
                    </header>
                  </div>
                  <div class="card-img d-flex">
                    <div class="prod-preview">
                      <div class="offer-icon">
                        <span class="material-symbols-outlined"> redeem </span>
                      </div>
                      <div>
                        <h3>{{ template.limited.text }}</h3>
                        <p>Offer end on Apr 23</p>
                        <p class="offer-code">Code YUP50</p>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <p class="card-text">{{ template.body.text }} <span class="time-span">10:20</span></p>
                    <footer class="card-text footer-item" v-if="template.footer">{{ template.footer.body }}</footer>
                    <div class="btn-whats-message">
                      <a><span class="material-symbols-outlined to-left">content_copy</span> Copiar código</a>
                    </div>
                    <div class="btn-whats-message">
                      <a><span class="material-symbols-outlined to-left">open_in_new</span> Acessar loja</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-preview" v-if="template.type == 'CUPOM'">
          <div style="overflow-x: auto" class="d-flex">
            <div class="col-9" style="padding: 0px; padding-right: 10px">
              <div class="card card-whats-message">
                <div class="card-content card-catalog">
                  <div class="card-body">
                    <header class="card-text padding-b-0" v-if="headerType === 'TEXT'">
                      <b>{{ headerPreview }}</b>
                    </header>
                    <header v-else-if="headerType === 'IMAGE'">
                      <div class="media">
                        <img :src="headerImage" v-if="headerImage" />
                      </div>
                    </header>
                    <header v-else-if="headerType === 'VIDEO'">
                      <div class="media">
                        <video :src="headerVideo" v-if="headerVideo" controls></video>
                      </div>
                    </header>
                    <header v-else-if="headerType === 'DOCUMENT'">
                      <div class="media">
                        <object type="application/pdf" :data="template.headerDocument.url" v-if="template.headerDocument"></object>
                      </div>
                    </header>
                    <p class="card-text">{{ template.body.text }} <span class="time-span">10:20</span></p>
                    <footer class="card-text footer-item padding-t-0" v-if="template.footer">{{ template.footer.body }}</footer>
                    <div class="btn-whats-message btn-whats-message-coupon">
                      <a><span class="material-symbols-outlined to-left">content_copy</span> {{ template.buttons.call_to_copy_code.text }}</a>
                    </div>
                    <div class="btn-whats-message btn-whats-message-coupon" style="border: none; display: none">
                      <a><span class="material-symbols-outlined to-left">open_in_new</span> Acessar loja</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-preview" v-if="template.buttons.type === 'QUICK_REPLY' || template.buttons.type === 'CALL_TO_ACTION'" v-show="false">
          <div class="card-body">
            <div class="preview-btns">
              <template v-if="template.buttons.type === 'QUICK_REPLY' && template.buttons.quick_replies">
                <template v-for="(reply, i) in template.buttons.quick_replies.filter((a) => !!a)">
                  <div class="btn" :key="i" :class="{ last: i === 2 }">{{ reply }}</div>
                </template>
              </template>
              <template v-if="template.buttons.type === 'CALL_TO_ACTION'">
                <div class="btn last" v-if="template.buttons.call_to_action_dial_phone.text">
                  <i class="fas fa-phone"></i>
                  {{ template.buttons.call_to_action_dial_phone.text }}
                </div>
                <div class="btn last" v-if="template.buttons.call_to_action_website.text">
                  <i class="fas fa-link"></i>
                  {{ template.buttons.call_to_action_website.text }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <img class="phone-img" src="@/assets/phone.svg" alt="Phone Background" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from '@/plugins/axios';
import datePicker from 'vue-bootstrap-datetimepicker';
// import MCrop from '@/components/MCrop.vue';
import BucketService from '@/services/bucket.service';
import WhatsAppService from '@/services/whatsapp.service';
import ImageUploader from '@/components/ImageUploader.vue';
import WhatsappButton from '@/components/whatsapp/WhatsappButton.vue';
import WhatsappBubble from '@/components/whatsapp/WhatsappBubble.vue';

export default {
  name: 'WhatsappSendForm',
  components: {
    datePicker,
    ImageUploader,
    WhatsappButton,
    WhatsappBubble,
    // MCrop,
  },
  props: ['recipients', 'extras', 'clientRoomId', 'showOld'],
  computed: {
    headerType() {
      return this.template?.header?.type || null;
    },
    headerBody() {
      return this.template?.header?.body || '';
    },
    customHeader() {
      const header = this.template?.header;
      return header?.type && (header?.type !== 'TEXT' || header.body?.indexOf('{{1}}') !== -1);
    },
    templateBodyParams() {
      const body = this.template?.body;

      return (
        body &&
        [...body?.text?.matchAll(/\{\{\d+}\}/g)].map((param, index) => {
          if (body.example_parameters[index]) return body.example_parameters[index];

          return `Parametro {{${index + 1}}}`;
        })
      );
    },
    customizable() {
      return this.customHeader || this.templateBodyParams?.length > 0;
    },
    headerCurrentVideo() {
      if (this.headerType === 'VIDEO') {
        return this.headerVideo || this.template?.header?.['example_parameter'];
      }
      return null;
    },
    headerCurrentDocument() {
      if (this.headerType === 'DOCUMENT') {
        return this.headerDocument || this.template?.header?.['example_parameter'];
      }

      return null;
    },
    headerCurrentImage() {
      if (this.headerType === 'IMAGE') {
        return this.headerImage || this.template?.header?.['example_parameter'];
      }

      return null;
    },
    headerPreview() {
      return this.template?.header?.body?.replace(/\{\{1\}\}/, (param) => this.headerParam || param);
    },
    bodyPreview() {
      return this.template?.body?.text?.replace(/\{\{(\d+)\}\}/g, (param) => {
        const index = param.slice(2, -2) - 1;

        return this.bodyParams[index] || param;
      });
    },
    headerResults() {
      const result = this.template?.header?.body;

      return !result ? '' : result.replace(/\{\{1\}\}/, (param) => this.headerParam || '');
    },
    bodyResults() {
      return this.template?.body?.text?.replace(/\{\{(\d+)\}\}/g, (param) => {
        const index = param.slice(2, -2) - 1;

        return this.bodyParams[index] ?? null;
      });
    },
    footerBody() {
      return this.template?.footer?.body;
    },
    validForm() {
      console.log('validForm', {
        headerType: this.headerType,
        'this.bodyResults?.indexOf(null)': this.bodyResults?.indexOf(null),
      });
      return (
        this.bodyResults?.indexOf(null) === -1 &&
        (!this.headerType ||
          (this.headerType === 'TEXT' && this.headerPreview.indexOf('{{1}}}') === -1) ||
          (this.headerType === 'IMAGE' && this.headerCurrentImage) ||
          (this.headerType === 'VIDEO' && this.headerCurrentVideo) ||
          (this.headerType === 'DOCUMENT' && this.headerCurrentDocument))
      );
    },
  },
  data() {
    return {
      visible: false,
      error: false,
      template: {},
      numbers: [],
      templates: [],
      businessId: null,
      currentNumberIndex: 0,
      currentTemplateIndex: -1,

      scheduled: false,
      scheduledFor: '',
      options: {
        format: 'DD/MM/YYYY HH:mm',
        useCurrent: true,
        minDate: moment(),
        locale: 'pt',
        keepInvalid: true,
      },

      foo: [
        {
          id: 1,
          name: 'Yup Chat',
          token:
            'EAAIHdrDSTM0BAMZCnHYW3h8XcXedd3BMkn7RYk4eIKuSoW3QuIz8ll8B0dLB1yeVLebdTBMHbgyJ2IZCZCXr67CWMt22geQvZCZA2f44W7SQMVyzZCfh3fAxHaUwsaFyrFZBGZCjbEhehu8C6vmjAimrrMeZBLpHAkmBFg8HJejbHZCwZDZD',
          deleted: false,
          creation_date: '2022-10-26T15:27:08.463192',
          account_id: '52867698-ac7b-4186-a7e9-8525161c8b7f',
          business_identification: '644721329205903',
          whatsapp_identification: '105694852190266',
          phone_identification: '108927061859720',
          phone_number: '558006911000',
          webhook_business_add: 'http://app.yup.chat:8097/webhook/whatsapp-java',
          webhook_business_update: 'http://app.yup.chat:8097/update/whatsapp-java',
        },
      ],
      bar: {
        content: [
          {
            id: '91',
            status: 'APPROVED',
            identification: '674073007750555',
            deleted: false,
            name: 'teste',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '68',
              type: 'TEXT',
              body: 'teste',
            },
            body: {
              id: '91',
              text: 'teste',
              example_parameters: [],
            },
            footer: {
              id: '79',
              body: 'teste',
            },
            creation_date: '2022-11-25T03:11:32.889',
            last_update: '2022-12-21T02:23:02.069',
            business_id: '105694852190266',
          },
          {
            id: '34',
            status: 'APPROVED',
            identification: '684117183143284',
            deleted: false,
            name: 'template_ola_body_teste',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            body: {
              id: '34',
              text: 'Boa tarde, {{1}}! Seu atendimento será iniciado por {{2}}.',
              example_parameters: ['Alex', 'Maria'],
            },
            creation_date: '2022-11-24T15:11:31.844',
            last_update: '2022-12-21T02:23:02.072',
            business_id: '105694852190266',
          },
          {
            id: '36',
            status: 'APPROVED',
            identification: '4047678695355993',
            deleted: false,
            name: 'erico_teste',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            body: {
              id: '36',
              text: 'Olá, tudo bem?',
              example_parameters: [],
            },
            creation_date: '2022-11-24T15:11:31.856',
            last_update: '2022-12-21T02:23:02.074',
            business_id: '105694852190266',
          },
          {
            id: '37',
            status: 'APPROVED',
            identification: '623142489556215',
            deleted: false,
            name: 'exemplo',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            body: {
              id: '37',
              text: 'teste',
              example_parameters: [],
            },
            creation_date: '2022-11-24T15:11:31.86',
            last_update: '2022-12-21T02:23:02.076',
            business_id: '105694852190266',
          },
          {
            id: '42',
            status: 'APPROVED',
            identification: '441574344774365',
            deleted: false,
            name: 'gui',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '29',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '42',
              text: 'body',
              example_parameters: [],
            },
            footer: {
              id: '35',
              body: 'footer',
            },
            creation_date: '2022-11-24T15:11:31.888',
            last_update: '2022-12-21T02:23:02.078',
            business_id: '105694852190266',
          },
          {
            id: '43',
            status: 'APPROVED',
            identification: '1268209477277740',
            deleted: false,
            name: 'string',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '30',
              type: 'TEXT',
              body: 'string',
            },
            body: {
              id: '43',
              text: 'string',
              example_parameters: [],
            },
            footer: {
              id: '36',
              body: 'string',
            },
            creation_date: '2022-11-24T15:11:31.892',
            last_update: '2022-12-21T02:23:02.08',
            business_id: '105694852190266',
          },
          {
            id: '61',
            status: 'APPROVED',
            identification: '4610507155718599',
            deleted: false,
            name: 'sample_happy_hour_announcement',
            language: 'en_US',
            category: 'APPOINTMENT_UPDATE',
            header: {
              id: '47',
              type: 'VIDEO',
            },
            body: {
              id: '61',
              text: 'Happy hour is here! 🍺😀🍸\nPlease be merry and enjoy the day. 🎉\nVenue: {{1}}\nTime: {{2}}',
              example_parameters: [],
            },
            footer: {
              id: '50',
              body: 'This message is from an unverified business.',
            },
            creation_date: '2022-11-24T15:11:32.001',
            last_update: '2022-12-21T02:23:02.12',
            business_id: '105694852190266',
          },
          {
            id: '62',
            status: 'APPROVED',
            identification: '1168720183984724',
            deleted: false,
            name: 'sample_happy_hour_announcement',
            language: 'pt_BR',
            category: 'APPOINTMENT_UPDATE',
            header: {
              id: '48',
              type: 'VIDEO',
            },
            body: {
              id: '62',
              text: 'O happy hour chegou! 🍺😀🍸\nSeja feliz e aproveite o dia. 🎉\nLocal: {{1}}\nHorário: {{2}}',
              example_parameters: [],
            },
            footer: {
              id: '51',
              body: 'Esta mensagem é de uma empresa não verificada.',
            },
            creation_date: '2022-11-24T15:11:32.007',
            last_update: '2022-12-21T02:23:02.123',
            business_id: '105694852190266',
          },
          {
            id: '63',
            status: 'APPROVED',
            identification: '741175846923877',
            deleted: false,
            name: 'sample_happy_hour_announcement',
            language: 'es',
            category: 'APPOINTMENT_UPDATE',
            header: {
              id: '49',
              type: 'VIDEO',
            },
            body: {
              id: '63',
              text: '¡Llegó el happy hour! 🍺😀🍸\nA divertirse y disfrutar. 🎉\nLugar: {{1}}\nHora: {{2}}',
              example_parameters: [],
            },
            footer: {
              id: '52',
              body: 'Este mensaje proviene de un negocio no verificado.',
            },
            creation_date: '2022-11-24T15:11:32.013',
            last_update: '2022-12-21T02:23:02.125',
            business_id: '105694852190266',
          },
          {
            id: '64',
            status: 'APPROVED',
            identification: '588102276264727',
            deleted: false,
            name: 'sample_happy_hour_announcement',
            language: 'id',
            category: 'APPOINTMENT_UPDATE',
            header: {
              id: '50',
              type: 'VIDEO',
            },
            body: {
              id: '64',
              text: 'Jam diskon telah tiba! 🍺😀🍸\nBergembiralah dan nikmati hari Anda. 🎉\nTempat: {{1}}\nWaktu: {{2}}',
              example_parameters: [],
            },
            footer: {
              id: '53',
              body: 'Pesan ini berasal dari bisnis yang tidak terverifikasi.',
            },
            creation_date: '2022-11-24T15:11:32.018',
            last_update: '2022-12-21T02:23:02.128',
            business_id: '105694852190266',
          },
          {
            id: '45',
            status: 'APPROVED',
            identification: '1227122324531255',
            deleted: false,
            name: 'template_teste_log_2',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '31',
              type: 'TEXT',
              body: 'Header log 2',
            },
            body: {
              id: '45',
              text: 'Body log 2',
              example_parameters: [],
            },
            footer: {
              id: '37',
              body: 'Footer log 2',
            },
            buttons: {
              id: '17',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Telefone',
                number: '+5583983553898',
              },
              call_to_action_website: {},
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.902',
            last_update: '2022-12-21T02:23:02.082',
            business_id: '105694852190266',
          },
          {
            id: '46',
            status: 'APPROVED',
            identification: '842799707078251',
            deleted: false,
            name: 'template_log_2',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '32',
              type: 'TEXT',
              body: 'Header teste',
            },
            body: {
              id: '46',
              text: 'Body teste',
              example_parameters: [],
            },
            footer: {
              id: '38',
              body: 'Footer teste',
            },
            buttons: {
              id: '18',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Telefone',
                number: '+5583983553898',
              },
              call_to_action_website: {},
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.911',
            last_update: '2022-12-21T02:23:02.084',
            business_id: '105694852190266',
          },
          {
            id: '47',
            status: 'APPROVED',
            identification: '418276057170866',
            deleted: false,
            name: 'template_teste_log',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '33',
              type: 'TEXT',
              body: 'Header log',
            },
            body: {
              id: '47',
              text: 'Body log',
              example_parameters: [],
            },
            footer: {
              id: '39',
              body: 'Footer log',
            },
            buttons: {
              id: '19',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Telefone',
                number: '+5583983553898',
              },
              call_to_action_website: {},
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.918',
            last_update: '2022-12-21T02:23:02.087',
            business_id: '105694852190266',
          },
          {
            id: '48',
            status: 'APPROVED',
            identification: '5986198824745830',
            deleted: false,
            name: 'um_template_de_teste3343434',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '34',
              type: 'TEXT',
              body: 'Um header',
            },
            body: {
              id: '48',
              text: 'Um body',
              example_parameters: [],
            },
            footer: {
              id: '40',
              body: 'Um footer',
            },
            buttons: {
              id: '20',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Telefone',
                number: '+5583983553898',
              },
              call_to_action_website: {},
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.923',
            last_update: '2022-12-21T02:23:02.089',
            business_id: '105694852190266',
          },
          {
            id: '49',
            status: 'APPROVED',
            identification: '501368715212372',
            deleted: false,
            name: 'um_template_de_teste',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '35',
              type: 'TEXT',
              body: 'Um template de teste',
            },
            body: {
              id: '49',
              text: 'Um body de teste',
              example_parameters: [],
            },
            footer: {
              id: '41',
              body: 'Um footer de teste',
            },
            buttons: {
              id: '21',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Telefone',
                number: '+5583983553898',
              },
              call_to_action_website: {},
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.93',
            last_update: '2022-12-21T02:23:02.091',
            business_id: '105694852190266',
          },
          {
            id: '50',
            status: 'APPROVED',
            identification: '782491569686895',
            deleted: false,
            name: 'template_teste_2',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '36',
              type: 'IMAGE',
            },
            body: {
              id: '50',
              text: 'Template com Header (Image) e CTAs',
              example_parameters: [],
            },
            buttons: {
              id: '22',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {
                text: 'Ligar...',
                number: '+5511993609755',
              },
              call_to_action_website: {
                text: 'Website',
                url: 'https://yup.chat/',
              },
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.939',
            last_update: '2022-12-21T02:23:02.093',
            business_id: '105694852190266',
          },
          {
            id: '51',
            status: 'APPROVED',
            identification: '1154666718420624',
            deleted: false,
            name: 'template_teste_1',
            language: 'pt_BR',
            category: 'MARKETING',
            header: {
              id: '37',
              type: 'TEXT',
              body: 'Header: {{1}}',
            },
            body: {
              id: '51',
              text: 'Body 1 = {{1}}\nBody 2 = {{2}}\nTeste',
              example_parameters: [],
            },
            buttons: {
              id: '23',
              type: 'QUICK_REPLY',
              call_to_action_dial_phone: {},
              call_to_action_website: {},
              quick_replies: ['Botao 1', 'Botao 2', 'Botao 3'],
            },
            creation_date: '2022-11-24T15:11:31.944',
            last_update: '2022-12-21T02:23:02.095',
            business_id: '105694852190266',
          },
          {
            id: '52',
            status: 'APPROVED',
            identification: '1121963188748382',
            deleted: false,
            name: 'template_ola',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '38',
              type: 'TEXT',
              body: '{{1}}',
              example_parameter: 'Bom Dia',
            },
            body: {
              id: '52',
              text: 'Olá, {{1}}! O atendimento será iniciado em breve!',
              example_parameters: ['Anthony'],
            },
            creation_date: '2022-11-24T15:11:31.949',
            last_update: '2022-12-21T02:23:02.098',
            business_id: '105694852190266',
          },
          {
            id: '55',
            status: 'APPROVED',
            identification: '1087076738545294',
            deleted: false,
            name: 'sample_flight_confirmation',
            language: 'pt_BR',
            category: 'TICKET_UPDATE',
            header: {
              id: '41',
              type: 'DOCUMENT',
            },
            body: {
              id: '55',
              text: 'Esta é a sua confirmação de voo para {{1}}-{{2}} em {{3}}.',
              example_parameters: [],
            },
            footer: {
              id: '44',
              body: 'Esta mensagem é de uma empresa não verificada.',
            },
            creation_date: '2022-11-24T15:11:31.965',
            last_update: '2022-12-21T02:23:02.105',
            business_id: '105694852190266',
          },
          {
            id: '60',
            status: 'APPROVED',
            identification: '786832625640706',
            deleted: false,
            name: 'sample_purchase_feedback',
            language: 'id',
            category: 'ISSUE_RESOLUTION',
            header: {
              id: '46',
              type: 'IMAGE',
            },
            body: {
              id: '60',
              text: 'Terima kasih sudah membeli {{1}}! Kami menghargai masukan Anda dan ingin mempelajari lebih lanjut terkait pengalaman Anda.',
              example_parameters: [],
            },
            footer: {
              id: '49',
              body: 'Pesan ini berasal dari bisnis yang tidak terverifikasi.',
            },
            buttons: {
              id: '27',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {},
              call_to_action_website: {
                text: 'Ikuti survei',
                url: 'https://www.example.com/',
              },
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.996',
            last_update: '2022-12-21T02:23:02.118',
            business_id: '105694852190266',
          },
          {
            id: '118',
            status: 'APPROVED',
            identification: '866470984370075',
            deleted: false,
            name: 'hthoixyenq0r3rrs7yje',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '84',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '118',
              text: 'gbIcWIzJoDzSKhbMg2Kf',
              example_parameters: [],
            },
            footer: {
              id: '92',
              body: 'footer',
            },
            creation_date: '2022-11-29T05:49:00.591',
            last_update: '2022-12-21T02:23:02.065',
            business_id: '105694852190266',
          },
          {
            id: '53',
            status: 'APPROVED',
            identification: '5179014765485000',
            deleted: false,
            name: 'sample_flight_confirmation',
            language: 'id',
            category: 'TICKET_UPDATE',
            header: {
              id: '39',
              type: 'DOCUMENT',
            },
            body: {
              id: '53',
              text: 'Ini merupakan konfirmasi penerbangan Anda untuk {{1}}-{{2}} di {{3}}.',
              example_parameters: [],
            },
            footer: {
              id: '42',
              body: 'Pesan ini berasal dari bisnis yang tidak terverifikasi.',
            },
            creation_date: '2022-11-24T15:11:31.954',
            last_update: '2022-12-21T02:23:02.1',
            business_id: '105694852190266',
          },
          {
            id: '54',
            status: 'APPROVED',
            identification: '1540296289699500',
            deleted: false,
            name: 'sample_flight_confirmation',
            language: 'es',
            category: 'TICKET_UPDATE',
            header: {
              id: '40',
              type: 'DOCUMENT',
            },
            body: {
              id: '54',
              text: 'Confirmamos tu vuelo a {{1}}-{{2}} para el {{3}}.',
              example_parameters: [],
            },
            footer: {
              id: '43',
              body: 'Este mensaje proviene de un negocio no verificado.',
            },
            creation_date: '2022-11-24T15:11:31.959',
            last_update: '2022-12-21T02:23:02.102',
            business_id: '105694852190266',
          },
          {
            id: '56',
            status: 'APPROVED',
            identification: '392228542931155',
            deleted: false,
            name: 'sample_flight_confirmation',
            language: 'en_US',
            category: 'TICKET_UPDATE',
            header: {
              id: '42',
              type: 'DOCUMENT',
            },
            body: {
              id: '56',
              text: 'This is your flight confirmation for {{1}}-{{2}} on {{3}}.',
              example_parameters: [],
            },
            footer: {
              id: '45',
              body: 'This message is from an unverified business.',
            },
            creation_date: '2022-11-24T15:11:31.972',
            last_update: '2022-12-21T02:23:02.108',
            business_id: '105694852190266',
          },
          {
            id: '57',
            status: 'APPROVED',
            identification: '4980056215449545',
            deleted: false,
            name: 'sample_purchase_feedback',
            language: 'en_US',
            category: 'ISSUE_RESOLUTION',
            header: {
              id: '43',
              type: 'IMAGE',
            },
            body: {
              id: '57',
              text: 'Thank you for purchasing {{1}}! We value your feedback and would like to learn more about your experience.',
              example_parameters: [],
            },
            footer: {
              id: '46',
              body: 'This message is from an unverified business.',
            },
            buttons: {
              id: '24',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {},
              call_to_action_website: {
                text: 'Take Survey',
                url: 'https://www.example.com/',
              },
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.978',
            last_update: '2022-12-21T02:23:02.11',
            business_id: '105694852190266',
          },
          {
            id: '58',
            status: 'APPROVED',
            identification: '1031705504139034',
            deleted: false,
            name: 'sample_purchase_feedback',
            language: 'es',
            category: 'ISSUE_RESOLUTION',
            header: {
              id: '44',
              type: 'IMAGE',
            },
            body: {
              id: '58',
              text: '¡Gracias por comprar {{1}}! Valoramos tus comentarios y nos gustaría saber cómo fue tu experiencia.',
              example_parameters: [],
            },
            footer: {
              id: '47',
              body: 'Este mensaje proviene de un negocio no verificado.',
            },
            buttons: {
              id: '25',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {},
              call_to_action_website: {
                text: 'Responder encuesta',
                url: 'https://www.example.com/',
              },
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.985',
            last_update: '2022-12-21T02:23:02.113',
            business_id: '105694852190266',
          },
          {
            id: '59',
            status: 'APPROVED',
            identification: '1022243005321602',
            deleted: false,
            name: 'sample_purchase_feedback',
            language: 'pt_BR',
            category: 'ISSUE_RESOLUTION',
            header: {
              id: '45',
              type: 'IMAGE',
            },
            body: {
              id: '59',
              text: 'Agradecemos a aquisição de {{1}}! Valorizamos seu feedback e gostaríamos de saber mais sobre sua experiência.',
              example_parameters: [],
            },
            footer: {
              id: '48',
              body: 'Esta mensagem é de uma empresa não verificada.',
            },
            buttons: {
              id: '26',
              type: 'CALL_TO_ACTION',
              call_to_action_dial_phone: {},
              call_to_action_website: {
                text: 'Participe da pesquisa',
                url: 'https://www.example.com/',
              },
              quick_replies: [],
            },
            creation_date: '2022-11-24T15:11:31.991',
            last_update: '2022-12-21T02:23:02.115',
            business_id: '105694852190266',
          },
          {
            id: '111',
            status: 'APPROVED',
            identification: '509430341218326',
            deleted: false,
            name: 'hhs38fm4meusxrwl0mch',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '77',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '111',
              text: 'EwXKpqY9QUYkmabvgy1D',
              example_parameters: [],
            },
            footer: {
              id: '85',
              body: 'footer',
            },
            creation_date: '2022-11-29T05:49:00.568',
            last_update: '2022-12-21T02:23:02.057',
            business_id: '105694852190266',
          },
          {
            id: '113',
            status: 'APPROVED',
            identification: '1135396380433635',
            deleted: false,
            name: 'az17sdomxekhavyyzbfg',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '79',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '113',
              text: '9uzHBb5PUhXD6CmaaiqV',
              example_parameters: [],
            },
            footer: {
              id: '87',
              body: 'footer',
            },
            creation_date: '2022-11-29T05:49:00.574',
            last_update: '2022-12-21T02:23:02.059',
            business_id: '105694852190266',
          },
          {
            id: '115',
            status: 'APPROVED',
            identification: '3454841628095701',
            deleted: false,
            name: 'dzucg2qwiepdtbro9dly',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '81',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '115',
              text: 'ZkJrvMoRGTAAOXuPRU57',
              example_parameters: [],
            },
            footer: {
              id: '89',
              body: 'footer',
            },
            creation_date: '2022-11-29T05:49:00.582',
            last_update: '2022-12-21T02:23:02.061',
            business_id: '105694852190266',
          },
          {
            id: '117',
            status: 'APPROVED',
            identification: '832847771321573',
            deleted: false,
            name: 'urtnnqdhh9g4z4m09edr',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '83',
              type: 'TEXT',
              body: 'header',
            },
            body: {
              id: '117',
              text: 'OGghajKFngos5ptzcvCn',
              example_parameters: [],
            },
            footer: {
              id: '91',
              body: 'footer',
            },
            creation_date: '2022-11-29T05:49:00.588',
            last_update: '2022-12-21T02:23:02.063',
            business_id: '105694852190266',
          },
          {
            id: '155',
            status: 'APPROVED',
            identification: '3168647603394790',
            deleted: false,
            name: 'sample_shipping_confirmation',
            language: 'id',
            category: 'SHIPPING_UPDATE',
            body: {
              id: '155',
              text: 'Paket Anda sudah dikirim. Paket akan sampai dalam {{1}} hari kerja.',
              example_parameters: [],
            },
            footer: {
              id: '113',
              body: 'Pesan ini berasal dari bisnis yang tidak terverifikasi.',
            },
            creation_date: '2022-12-19T20:27:13.026',
            last_update: '2022-12-21T02:23:02.13',
            business_id: '105694852190266',
          },
          {
            id: '156',
            status: 'APPROVED',
            identification: '806614247319731',
            deleted: false,
            name: 'sample_shipping_confirmation',
            language: 'en_US',
            category: 'SHIPPING_UPDATE',
            body: {
              id: '156',
              text: 'Your package has been shipped. It will be delivered in {{1}} business days.',
              example_parameters: [],
            },
            footer: {
              id: '114',
              body: 'This message is from an unverified business.',
            },
            creation_date: '2022-12-19T20:27:13.033',
            last_update: '2022-12-21T02:23:02.133',
            business_id: '105694852190266',
          },
          {
            id: '157',
            status: 'APPROVED',
            identification: '557496575912254',
            deleted: false,
            name: 'sample_shipping_confirmation',
            language: 'es',
            category: 'SHIPPING_UPDATE',
            body: {
              id: '157',
              text: 'ó tu paquete. La entrega se realizará en {{1}} dí.',
              example_parameters: [],
            },
            footer: {
              id: '115',
              body: 'Este mensaje proviene de un negocio no verificado.',
            },
            creation_date: '2022-12-19T20:27:13.036',
            last_update: '2022-12-21T02:23:02.135',
            business_id: '105694852190266',
          },
          {
            id: '158',
            status: 'APPROVED',
            identification: '546153000314171',
            deleted: false,
            name: 'sample_shipping_confirmation',
            language: 'pt_BR',
            category: 'SHIPPING_UPDATE',
            body: {
              id: '158',
              text: 'Seu pacote foi enviado. Ele será entregue em {{1}} dias úteis.',
              example_parameters: [],
            },
            footer: {
              id: '116',
              body: 'Esta mensagem é de uma empresa não verificada.',
            },
            creation_date: '2022-12-19T20:27:13.04',
            last_update: '2022-12-21T02:23:02.138',
            business_id: '105694852190266',
          },
          {
            id: '159',
            status: 'APPROVED',
            identification: '854154459124581',
            deleted: false,
            name: '1_header_image',
            language: 'pt_BR',
            category: 'TRANSACTIONAL',
            header: {
              id: '104',
              type: 'IMAGE',
              body: '',
              example_parameter: 'https://web-api.yup.chat/bucket/52867698-ac7b-4186-a7e9-8525161c8b7f/public/whatsapp/e77a161a-e78d-4bec-ad50-dfd1471cccf5',
            },
            body: {
              id: '159',
              text: 'TESTE',
              example_parameters: [''],
            },
            footer: {
              id: '117',
              body: 'teste',
            },
            creation_date: '2022-12-21T11:51:05.189',
            last_update: '2022-12-21T11:51:05.189',
            business_id: '105694852190266',
          },
        ],
        pageable: {
          sort: {
            sorted: false,
            unsorted: true,
            empty: true,
          },
          pageNumber: 0,
          pageSize: 50,
          offset: 0,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 36,
        first: true,
        sort: {
          sorted: false,
          unsorted: true,
          empty: true,
        },
        numberOfElements: 36,
        size: 50,
        number: 0,
        empty: false,
      },

      // recebe string do parametro ou url de um arquivo
      headerParam: '',

      // Temporario para evitar reupload
      headerVideo: null,
      headerDocument: null,
      headerImage: null,

      // Parametros preenchidos pelo usuário
      bodyParams: [],

      uploading: false,
      sending: false,
    };
  },
  created() {
    // this.$root.$on('call.crop', this.crop);
    this.$root.$on('whatsapp.changeTemplate', this.callTemplates);
  },
  mounted() {
    // this.numbers = this.foo;
    this.currentNumberIndex = 0;
    this.fetchNumbers();
  },
  methods: {
    callUpload(file, card) {
      card.components[0].example.header_handle[0] = file.url;
      this.$forceUpdate();
    },
    callTemplates(template) {
      this.template = template;
      if (template.headerVideo) {
        this.headerVideo = template.headerVideo.url;
      }
      if (template.headerImage) {
        this.headerImage = template.headerImage.url;
      }
      this.$forceUpdate();
      console.log('Template change', template);
    },
    changeTemplate() {
      this.bodyParams = [];
      this.headerVideo = null;
      this.headerDocument = null;
      this.headerImage = null;
      this.headerParam = '';
    },
    fetchNumbers() {
      this.error = false;
      this.sending = true;

      axios()
        .get('whatsapp/new/numbers')
        .then(
          (response) => {
            response.data.forEach((data) => {
              this.numbers.push(data);
            });
            console.log('WhatsNumbers', response.data, this.numbers);
            this.fetchTemplates();
          },
          (error) => {
            this.error = true;
            this.sending = false;
          },
        );
    },
    fetchTemplates() {
      const currentNumber = this.numbers[this.currentNumberIndex];

      console.log({ currentNumber });

      if (currentNumber) {
        const businessId = currentNumber.whatsapp_identification;
        // const phoneNumber = currentNumber.phone_number;

        // this.templates = this.bar.content.filter((entry) => entry.status === 'APPROVED');

        // .map((template) => {
        //   // if (x.body && 'text' in x.body) x.body.text = 'teste {{1}} {{2}}';
        //   // template.businessId = businessId;
        //   // template.phoneNumber = phoneNumber;
        //   return template;
        // });

        WhatsAppService.getNewTemplates(businessId, {
          params: {
            page: 0,
            size: 200,
          },
        })
          .then(
            (response) => {
              if (response && response.data && response.data.content) {
                this.templates = response.data.content.filter((entry) => entry.status === 'APPROVED');
              } else {
                console.error('invalid templates', response);
              }
              console.log('fetchTemplates', this.templates);
            },
            (error) => {
              console.error(error);
              this.error = true;
            },
          )
          .finally(() => {
            this.sending = false;
          });
      }
    },
    chooseImage(maxWidth, maxHeight) {
      this.$root.$emit('show.modal', 'm-crop');
      const x = this.$store.dispatch('crop/config', {
        maxWidth,
        maxHeight,
        viewMode: 1,
        aspectRatio: 2,
        minSize: true,
        infoSize: '1700x800',
      });

      console.log({ selectFile: x });
    },
    crop(data) {
      this.$root.$emit('show.modal', 'request-modal');

      console.log('crop', { selectFile: data });

      if (data) this.uploadFile(data);
    },
    selectFile(event) {
      const file = event.target?.files[0];

      console.log('selectFile', { selectFile: file });

      if (file) this.uploadFile(file);
    },
    uploadFile(handle) {
      const type = this.headerType;

      console.log('uploadFile', {
        handle,
        type,
      });

      if (!handle || !type || type === 'TEXT') return;

      const form = new FormData();

      let file;

      if (type === 'IMAGE') {
        const crop = JSON.stringify([
          {
            x: handle.x,
            y: handle.y,
            w: handle.width,
            h: handle.height,
          },
        ]);

        form.append('crop', crop);

        file = handle.file;
      } else {
        file = handle;
      }

      form.append('files[]', file);
      form.append('role', 'public');
      form.append('folder', 'whatsapp');
      form.append('account_id', this.$store.state.account.id);

      this.uploading = true;

      BucketService.upload(form, true, (progress) => {
        this.uploadProgress = progress;
      })
        .then((responses) => {
          const url = responses.data[0].url;

          if (type === 'IMAGE') {
            this.headerImage = url;
          } else if (type === 'VIDEO') {
            this.headerVideo = url;
          } else if (type === 'DOCUMENT') {
            this.headerDocument = url;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    sendMessage() {
      const template = this.template;

      console.log('sendMessage');

      if (!this.validForm) {
        console.error('Invalid form');
        return;
      }

      if (!template.name) {
        console.error('Invalid template name');
        return;
      }

      let scheduled = null;

      if (this.scheduled) {
        const parsed = moment(this.scheduledFor, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

        if (!parsed || Number.isNaN(Date.parse(parsed))) {
          console.error('Invalid date', parsed);
          return;
        }

        scheduled = new Date(parsed).toISOString();
      }

      const currentNumber = this.numbers[this.currentNumberIndex];
      const phoneNumber = currentNumber.phone_number;

      let recipientsInput = this.recipients.replace(/(\d)[\\\- ](\d)/, '$1$2');

      recipientsInput = recipientsInput.replace(/[()+]/g, '');

      let invalid = null;
      let recipients = recipientsInput.split(/[;,\r\n]/).map((number) => {
        const cleanNumber = number
          .trim()
          .replace(/\D+/g, '')
          .replace(/((\r)?\n)+/g, '');

        if (cleanNumber !== '' && cleanNumber.length < 11) invalid = number;

        return cleanNumber;
      });

      if (invalid !== null) {
        this.$toast.show({
          title: 'Erro',
          content: `Telefone inválido: ${invalid}`,
          type: 'danger',
          rejectBtn: null,
          requireInteraction: (accepted) => {},
        });
        this.$emit('error');
        return;
      }

      // Remove duplicate
      recipients = recipients.filter((v, i, a) => v !== '' && a.indexOf(v) === i);

      let headerParam = null;

      // simple:
      // const payload = {
      //   client_number: recipients.join(','),
      //   body_parameters: this.bodyParams,
      //   language_code: template.language,
      //   template_name: template.name,
      //   business_id: template.business_id,
      //   from: phoneNumber,
      //   type: 'template',
      // };

      const payload = {
        client_number: '',
        body_parameters: this.bodyParams,
        business_id: template.business_id,
        language_code: template.language,
        template_id: template.id,
        from: phoneNumber,
      };

      const clientRoomId = this.clientRoomId;

      if (clientRoomId) {
        if (!this.$live.myUserId) {
          this.$toast.show({
            title: 'Erro',
            content: 'não esta conectado ou não é um agent',
            type: 'danger',
            rejectBtn: null,
            requireInteraction: (accepted) => {},
          });
          this.$emit('error');
          return;
        }

        payload.agent_id = this.$live.myUserId;
        payload.account_id = this.$live.accountId;
        payload.client_id = clientRoomId;
        payload.message = this.bodyPreview;
      }

      if (this.headerType === 'TEXT') {
        headerParam = this.headerParam === '' || this.headerParam === false || this.headerParam === null ? null : this.headerParam;
      } else if (this.headerType === 'VIDEO') {
        headerParam = this.headerCurrentVideo;
      } else if (this.headerType === 'DOCUMENT') {
        headerParam = this.headerCurrentDocument;
      } else if (this.headerType === 'IMAGE') {
        headerParam = this.headerCurrentImage;
      }

      if (headerParam !== null) {
        payload.header_type = this.headerType;
        payload.header_parameter = headerParam;
      }

      if (scheduled) payload.scheduled_to = scheduled;

      this.sending = true;

      const messages = recipients.map((clientNumber) => {
        const clone = JSON.parse(JSON.stringify(payload));
        clone.client_number = clientNumber;
        return clone;
      });

      console.log('sendMessage', messages);

      let req;

      if (clientRoomId) {
        req = this.$live.sendTemplate(messages[0]);
      } else {
        req = axios().post('whatsapp/new/send/templates', { messages });
      }

      req
        .then((responses) => {
          console.log({ responses });
          this.$toast.show({
            title: 'Sucesso',
            content: 'Mensagem enviada com sucesso!',
            type: 'success',
            rejectBtn: null,
            requireInteraction: (accepted) => {},
          });
          this.$emit('success');
        })
        .catch((error) => {
          console.error({ error });
          this.$toast.show({
            title: 'Erro',
            content: error,
            type: 'danger',
            rejectBtn: null,
            requireInteraction: (accepted) => {},
          });
          this.$emit('error');
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  min-height: 200px;

  .qt-loader {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.32);
    height: 100%;
    width: 100%;

    &:before {
      top: 20%;
      left: 50%;
    }
  }

  .label-send-check {
    margin-left: 10px;
    margin-top: 2px;
  }

  .custom-control-inline {
    margin-right: 0 !important;
    padding-left: 0 !important;
  }
}

.btn-link-preview .btn {
  box-shadow: 0px 2px 3px #0000001a;
  color: var(--foreground);
}

.preview {
  border-radius: 0.2rem;
  background-color: #e5ddd5;
  box-sizing: border-box;
  // min-height: 400px;
  padding: 15px;
  position: relative;

  &::before {
    background: url('/assets/img/chat-bg.png');
    background-size: 366px 666px;
    content: '';
    opacity: 0.06;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .preview-sample {
    max-width: 340px;
    position: sticky;
    top: 92px;
  }

  .preview-message,
  .preview-btns .btn {
    box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.15);
    background-color: #fff;
    border-radius: 0.32rem;
    width: 100%;
  }

  .preview-btns {
    margin: 0 !important;

    .btn {
      border: none;
      min-height: 32px;
      width: calc(50% - 0.25rem);
      margin: 0.25rem 0.25rem 0.5rem 0;

      &:nth-child(2) {
        margin: 0.25rem 0 0.5rem 0.25rem;
      }

      &.last {
        margin: 0.25rem 0 0.25rem 0;
        width: 100%;
      }
    }
  }

  .preview-message {
    border-top-left-radius: 0;
    padding: 0.25rem 0.25rem 0 0.25rem;
    position: relative;
    z-index: 2;
    min-height: 32px;

    & > header,
    & > div,
    & > footer {
      margin-bottom: 0.25rem;
      padding: 0.25rem;
    }

    & > time {
      position: absolute;
      bottom: 0.25rem;
      right: 0.5rem;
      font-size: 75%;
    }

    & > footer {
      color: rgb(140, 140, 140);
    }

    & > header {
      overflow: hiddden;
      max-height: 280px;
      max-height: 100%;
      font-weight: bold;

      .media {
        min-height: 100px;
        border-radius: 0.32rem;
        background: #ececec;
        margin-bottom: 0.2rem;
        overflow: hidden;

        & > img,
        & > object,
        & > video {
          object-fit: cover;
          width: 100%;
        }

        &.document {
          position: relative;
          min-height: 60px;
          height: 60px;

          img {
            position: absolute;
            width: 26px;
            height: 30px;
            left: 0.5rem;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}

/* Rebranding */
.preview-div {
  display: flex;
  // position: relative;
  /* align-items: center; */
  position: sticky;
  top: 100px;
  height: fit-content;
}

.preview-wrapper {
  width: 100%;
  height: fit-content;
}

.phone-img {
  margin-left: auto;
  width: 20rem;
  height: fit-content;
}

@media (min-width: 768px) {
  ::v-deep label {
    font-size: 1rem !important;
  }

  .phone-img {
    position: absolute;
    // right: 0;
    right: 50px;
    padding-right: 3rem;
    margin-top: 10%;
    z-index: -1;
  }

  .preview-wrapper {
    /* position: sticky;
    top: 100px; */
    display: flex;
    align-items: center;
    height: 472px;
  }

  .card-preview {
    position: absolute;
    width: 410px;
    // top: 200px;
    right: -10%;
    margin-top: 4rem;
    margin-bottom: 0 !important;
  }

  .card-preview .card-body {
    padding: 3rem 1rem;
  }
}

/* btn Preview style */
.preview-message-btns {
  border-top: 1px solid #dadde1;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  padding: 5px;
  color: #00a5f4;
  font-size: 14px;
  line-height: 20px;

  .btn {
    &:nth-child(1) {
      float: left;
      width: 48%;
    }

    &:nth-child(2) {
      float: right;
      width: 48%;
    }

    &.max {
      width: 100%;
    }
  }
}

.preview-message-btns i {
  color: #00a5f4;
}

.preview-message-btns span {
  display: flex;
  margin-bottom: 8px;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.725rem;
}

.c-pointer {
  cursor: pointer !important;
}

.media {
  video {
    max-height: 220px;
  }
}

.img-wrapper {
  display: flex;
  justify-content: center;
}

.card-options {
  position: absolute;
  top: -70px;
  right: 0;
  width: 330.633px;
  // min-width: 330.633px;
  // max-width: 330.633px;
  // min-height: 200px;
  background-color: #00000038;
  backdrop-filter: blur(10px);
  z-index: 5;

  .card-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: #000000b2;
    color: #fff;
    padding: 0.285rem 1rem;

    button {
      height: fit-content;
    }
  }

  .card-body {
    background-color: #0000009c;
  }

  .form-control {
    background-color: #000000a1 !important;
    border-color: #000 !important;
    color: #fff;
  }

  .material-icons-outlined.chevron {
    transition: 0.5s;
    color: #fff;
  }

  .material-icons-outlined.chevron.open {
    transform: rotate(-180deg);
  }
}

.card-header {
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.midia-container-template {
  margin-bottom: 10px;
  background: #f5f5f5;
}

.card-header {
  font-weight: 700 !important;
}

.img-wrapper {
  margin-bottom: 10px;
}

.image-container {
  text-align: center;
  margin-bottom: 10px;
  background: #eff2f7;
  padding: 25px;
  width: 100%;
}

.image-container img {
  width: 20%;
}

.card-upload-btn {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.card-upload-btn:hover {
  color: #a4a4a4;
  font-size: 19px;
}

.edit-body-card-icon {
}

.content::v-deep {
  .vti__dropdown {
    background: #fff;
  }
}

.category {
  color: #0d0d0d;

  .col-2 {
    text-align: center;

    & > i {
      font-size: 24pt;
    }
  }

  .col-10 > h3,
  .col-2 > i {
    color: inherit !important;
  }
}

.preview {
  border-radius: 0.2rem;
  background-color: #e5ddd5;
  box-sizing: border-box;
  height: 100%;
  padding: 15px;
  position: relative;

  &::before {
    background: url('/assets/img/chat-bg.png');
    background-size: 366px 666px;
    content: '';
    opacity: 0.06;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .preview-sample {
    max-width: 340px;
    position: sticky;
    top: 92px;
  }

  .preview-message,
  .preview-btns .btn {
    box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.15);
    background-color: #fff;
    border-radius: 0.32rem;
    width: 100%;
  }

  .preview-btns {
    margin: 0 !important;

    .btn {
      border: none;
      min-height: 32px;
      width: calc(50% - 0.25rem);
      margin: 0.25rem 0.25rem 0.5rem 0;

      &:nth-child(2) {
        margin: 0.25rem 0 0.5rem 0.25rem;
      }

      &.last {
        margin: 0.25rem 0 0.25rem 0;
        width: 100%;
      }
    }
  }

  .preview-message {
    border-top-left-radius: 0;
    padding: 0.25rem 0.25rem 0 0.25rem;
    position: relative;
    z-index: 2;
    min-height: 32px;

    & > header,
    & > div,
    & > footer {
      margin-bottom: 0.25rem;
      padding: 0.25rem;
    }

    & > time {
      position: absolute;
      bottom: 0.25rem;
      right: 0.5rem;
      font-size: 80%;
    }

    & > footer {
      color: rgb(140, 140, 140);
    }

    & > header {
      overflow: hiddden;
      max-height: 280px;
      max-height: 100%;
      font-weight: bold;

      .media {
        min-height: 100px;
        border-radius: 0.32rem;
        background: #ececec;
        margin-bottom: 0.2rem;
        overflow: hidden;

        & > img,
        & > object,
        & > video {
          object-fit: cover;
          width: 100%;
        }
      }
    }
  }
}

/* Rebranding */
.body-section {
  position: relative;
}

.input-info {
  position: absolute;
  right: 20px;
  top: unset;
  color: #aaa;
  bottom: -30px;
}

.input-info.text-area {
  top: 270px;
}

.new-template-whats {
  padding: 15px 15px 33px;
  margin: 0 auto;
  background: var(--background-2);
  margin: 10px;
}

.new-template-title {
  color: rgb(28, 30, 33);
}

.darkmode .new-template-title,
.darkmode .new-template-whats p span {
  color: #fff;
}

.new-template-whats p span {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: normal;
  overflow-wrap: normal;
  text-align: left;
  color: rgb(96, 103, 112);
}

.carousel-visible {
  position: sticky;
  top: 100px;
}

.carousel-template .carousel-indicators li {
  width: 15px;
  height: 15px;
  background-color: var(--clr-yup-purple);
  border-radius: 50%;
}

.carousel-template::v-deep {
  .carousel-item[role='listitem'] {
    margin-bottom: 1.2rem !important;

    & > img {
      display: none !important;
    }
  }

  .carousel-caption {
    position: static !important;

    & > p {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
}

.carousel-template::v-deep .carousel-indicators li {
  width: 15px;
  height: 15px;
  background-color: var(--clr-yup-purple);
  border-radius: 50%;
}

.carousel-template::v-deep .carousel-control-next-icon,
.carousel-template::v-deep .carousel-control-prev-icon {
  width: 100%;
  height: 45px;
  position: relative;
}

.carousel-template::v-deep .carousel-control-next-icon::after,
.carousel-template::v-deep .carousel-control-prev-icon::after {
  color: var(--clr-yup-purple);
  font-weight: 400;
  font-family: 'Material Icons';
  right: 0;
  top: 10px;
  width: 100%;
}

.carousel-template::v-deep .carousel-control-next-icon::after {
  content: '\e5e1' !important;
}

.carousel-template::v-deep .carousel-control-prev-icon::after {
  content: '\e2ea';
}

.carousel-indicators {
  bottom: -1.5rem;
}

.icon-template span {
  color: var(--clr-yup-purple);
  font-size: 122px;
}

.new-template-whats {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.optional-template-input {
  display: block;
  float: left;
  font-size: 12px;
  background: #f4f4f4;
  padding: 5px;
  border-radius: 10px;
  transform: translateY(-8px) translateX(-5px) scale(0.8);
}

.darkmode .optional-template-input {
  background: var(--background-3);
}

.button-icon {
  height: fit-content;
  padding: 0;
}

.media-icon {
  height: fit-content;
  font-size: 1.75rem;
  transition: 0.5s;
  padding: 9px;
  cursor: pointer;
}

.media-icon.active {
  color: var(--clr-yup-purple);
}

.media-icon:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

::v-deep .body-section .textarea-information {
  display: none;
}

::v-deep body {
  background-color: #fff;
}

.create-template-section {
  background: transparent;
  box-shadow: unset;
}

/* Phone preview */
.preview-div {
  display: flex;
  position: sticky;
  /* align-items: center; */
  height: fit-content;
  top: 100px;
}

.preview-wrapper {
  width: 100%;
  // height: fit-content; // Position-sticky
  // height: 512px;
  z-index: 1;
}

.phone-img {
  margin-left: auto;
  width: 20rem;
  height: fit-content;
}

.preview-btns .btn {
  color: var(--foreground);
}

.btn.last {
  width: 100%;
}

@media (min-width: 768px) {
  ::v-deep label {
    font-size: 1rem !important;
  }

  .phone-img {
    position: absolute;
    right: 0;
    padding-right: 3rem;
    // margin-top: 10%; // Position-sticky
    z-index: -1;
  }

  .preview-wrapper {
    /* position: sticky;
    top: 100px; */
    display: flex;
    align-items: center;
    height: 512px;
    flex-wrap: wrap;
  }

  .card-preview {
    // position: absolute; // Position-sticky
    position: relative;
    width: 410px;
    // top: 200px; // Position-sticky
    // right: 20%; // Position-sticky
    right: -20px;
    margin-left: auto;
    margin-bottom: 1rem;
    min-height: 93px;
    --gap: 0.5rem;
    background: #efe7dc;
    border: solid 1px #e0e0e0;
  }

  .card-preview .card-body {
    padding: 1rem 1rem 2rem;
    display: flex;
    flex-direction: column;

    video {
      max-width: 200px;
      margin-left: auto;
      margin-right: auto;
    }

    img,
    object {
      margin-left: auto;
      margin-right: auto;
    }

    .img-loading {
      width: 378px;
      height: 189px;
    }
  }
}

.rebranding .card.card-preview .card-text.footer-item {
  color: var(--gray-font-color);
  margin-bottom: 0;
}

.card-preview:first-of-type {
  margin-top: calc(10 * var(--gap));
}

.card-preview:last-of-type {
  margin-bottom: calc(35 * var(--gap));
}

.card-preview:last-of-type .card-body {
  padding: 1rem;
}

.preview-btns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.sort-group,
.create-group {
  width: auto;
}

.card-btn-action {
  background-color: var(--background-3);
}

/* btn Preview style */
.preview-message-btns {
  border-top: 1px solid #dadde1;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  padding: 5px;
  color: #00a5f4;
  font-size: 14px;
  line-height: 20px;
}

.preview-message-btns i {
  color: #00a5f4;
}

.preview-message-btns span {
  display: block;
  margin-bottom: 8px;
}

@media (min-width: 768px) and (max-width: 1650px) {
  .card-preview {
    margin-right: auto;
  }
}

.btn-wrapper {
  display: flex;
  align-items: center;
}

/* Preview */
.preview-wrapper {
  position: sticky;
  top: 90px;
}

.card-preview {
  padding: 10px;
  border-radius: 8px;
}

.card-preview .card {
  box-shadow: none !important;
  border-radius: 15px !important;
  overflow: hidden;
}

.card-preview .card-body {
  padding: 8px !important;
}

.card-preview .media {
  overflow: hidden;
  border-radius: 8px;
}

.type-row .card {
  flex: 1;
  margin: 3px;
}

.image-default-header {
  height: 150px;
  width: 100%;
  object-fit: cover;
}

.type-row span.material-symbols-outlined {
  font-size: 25px !important;
}

.btn-whats-message {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  border-top-color: #e0e0e0 !important;
  border-top-width: 1px !important;
  border-top: solid;
}

.btn-whats-message a {
  display: block;
  justify-content: center;
  padding: 5px;
  color: #389dc9 !important;
  font-weight: 500;
  font-size: 15px;
  margin-right: 5px;
  margin-top: 3px;
}

.btn-whats-message a span {
  font-size: 15px;
  margin-top: 5px;
  margin-right: 5px;
}

.card-img {
  padding: 5px;
}

.card-img-top {
  border-radius: 10px;
}

.card-catalog .card-img {
  background: #f6f6f6;
  padding: 5px;
}

.card-catalog .prod-preview {
  display: flex;
  height: auto;
}

.prod-preview img {
  padding: 10px;
  width: 70px;
  background: #000;
}

.prod-preview h3 {
  font-size: 16px;
  margin: 0;
  margin-left: 10px;
}

.prod-preview p {
  color: #adadad;
  font-weight: 100;
  margin-left: 10px;
  margin-bottom: 0px;
}

.card-catalog .card-text {
  margin-bottom: 0px;
}

.footer-item {
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 0px;
}

.card-text {
  padding-bottom: 15px;
}

.time-span {
  position: absolute;
  right: 10px;
  color: #ccc;
  font-size: 13px;
  bottom: 5px;
}

.type-row .card-header.active {
  background: #752de6 !important;
}

.type-row .card-header:hover {
  background: #d0d0d0 !important;
}

.type-row .card-header.active button span {
  color: #fff !important;
}

.type-row .card-header.active button .wrapper-title p {
  color: #fff;
}

.offer-icon {
  width: 50px;
  height: 50px;
  background: #a0f7b3;
  border-radius: 50%;
  margin-left: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.offer-icon span {
  color: #47ad5e;
}

.offer-code {
  color: #c6c6c6;
}

.padding-b-0 {
  padding-bottom: 0px !important;
}

.padding-t-0 {
  padding-top: 0px !important;
}

.btn-whats-message-coupon a span {
  font-size: 15px !important;
  margin-top: 3px !important;
  margin-right: 5px;
}

.btn-whats-message-coupon a {
  font-size: 13px !important;
}

.h-160 {
  height: 160px !important;
}

.card-img-top {
  object-fit: cover;
  background: #000;
}

.video-header {
  width: 271px;
  height: 180px;
  background: #000;
}

.toggle-check .control .control_indicator {
  margin-right: 0px !important;
}

.edit_square_icon {
  font-size: 18px;
  margin: 8px;
}

.img-upload-icon {
  position: absolute;
  right: 30px;
  top: 15px;
}

.img-edit-icon {
  position: absolute;
  right: 30px;
  top: 45px;
}

.img-upload-icon span i {
  color: #fff;
}

.input-example-card {
  font-size: 10px;
  height: 25px;
}

.color-bcbcbc {
  color: #bcbcbc !important;
}

.card-preview {
  overflow-y: scroll;
  max-height: 500px;
}

.minutes-info {
  margin-bottom: 0px !important;
  font-size: 13px;
  color: #c1c1c1cc !important;
}

.m-b-0 {
  margin-bottom: 0px !important;
}
</style>
